import { getConfigBaseUrl } from '../../../services/apiService';
import { getCounterpartyId } from '../../../services/authService';
import { apiCall, createApiThunk } from '../../../utils/api';

export const getActiveUsersThunk = createApiThunk('GET_ACTIVE_USERS', apiCall);
export const getUserDetailsThunk = createApiThunk('GET_USER_DETAILS', apiCall);
export const getAllGroupsThunk = createApiThunk('GET_GROUPS', apiCall);
export const getGroupDetailsThunk = createApiThunk('GET_SELECTED_GROUP', apiCall);
export const getClientDetailsThunk = createApiThunk('GET_SELECTED_CLIENT', apiCall);
export const editUserThunk = createApiThunk('EDIT_USER', apiCall);
export const saveUserThunk = createApiThunk('SAVE_USER', apiCall);
export const getDraftUsersThunk = createApiThunk('GET_DRAFT_USERS', apiCall);
export const activateUserThunk = createApiThunk('ACTIVATE_USER', apiCall);
export const deactivateUserThunk = createApiThunk('DEACTIVATE_USER', apiCall);
export const deleteUserThunk = createApiThunk('DELETE_USER', apiCall);

export const getActiveUsers = () => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/users`;
  return dispatch(getActiveUsersThunk({ url }));
};

export const getUserDetails = (userId) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/users/${userId}`;
  return dispatch(getUserDetailsThunk({ url }));
};

export const getAllGroups = () => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/groups/`;
  return dispatch(getAllGroupsThunk({ url }));
};

export const getGroupDetails = (groupId: string) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/groups/${groupId}`;
  return dispatch(getGroupDetailsThunk({ url }));
};

export const getClientDetails = (clientId: string) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/clients/${clientId}`;
  return dispatch(getClientDetailsThunk({ url }));
};

export const editUser = (data: any) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/users/${data.userId}`;
  const method = 'PUT';
  return dispatch(editUserThunk({ url, method, data }));
};

export const saveUser = (data: any) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/users/`;
  const method = 'POST';
  return dispatch(saveUserThunk({ url, method, data }));
};

export const getDraftUsers = () => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/draft/users`;
  return dispatch(getDraftUsersThunk({ url }));
};

export const activateUser = (data: any) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/users/enable/${data.userId}`;
  const method = 'PUT';
  return dispatch(activateUserThunk({ url, method, data }));
};

export const deactivateUser = (data: any) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/users/disable/${data.userId}`;
  const method = 'PUT';
  return dispatch(deactivateUserThunk({ url, method, data }));
};

export const deleteUser = (data: any) => (dispatch: any) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/users/${data.userId}`;
  const method = 'DELETE';
  return dispatch(deleteUserThunk({ url, method, data }));
};
